import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Portal from 'modules/core/components/Portal'

import styles from './index.module.css'

interface Props {
  close: () => void
  description: string
  title: string
  cta: string
}

const CompleteModal = ({ close, cta, title, description }: Props) => (
  <Portal locked onClose={close}>
    <div className={styles.modal}>
      <div className={styles.content}>
        <div className={styles.background} />
        <div className={styles.box}>
          <Box
            width="full"
            background="viridian1000"
            borderRadius={{
              all: 'abs008',
            }}
            boxShadow="s200"
            padding="s40"
            paddingTop="s80"
          >
            <div className={styles.illustration}>🎉</div>
            <header className={styles.header}>
              <h5 className={styles.pretitle}>{title}</h5>
              <h3 className={styles.title}>{description}</h3>
              <div className={styles.separator} />
            </header>
            <Box alignItems="center" paddingTop="s40">
              <Button onClick={close} type="upgrade">
                {cta}
              </Button>
            </Box>
          </Box>
        </div>
      </div>
    </div>
  </Portal>
)

export default CompleteModal
